import React from 'react';
import {RedocStandalone} from "redoc";
import apiJson from "./mabriteccentral-api.json";

const APIRedoc: React.FC = () => {

    return (
        <RedocStandalone
            spec={apiJson}
            options={{
                downloadFileName: "mabriteccentral-api.json",
                // theme: { colors: { primary: { main: "#dd5522" } } }, // Optional customization
                //scrollYOffset: "100", // Adjusts scroll offset for navigation
            }}
        />
    );
}

export default APIRedoc;